import React from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog, DialogActions, DialogContent, Grid } from '@mui/material'
import i18n from 'simple-react-i18n'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { push } from '@lagunovsky/redux-react-router'
import { DefaultDialogTitle } from 'components/styled/Dialog'

export default function ModalWarnNoConso({ open, toggleModal, onValidateDeclaration, instsWithoutIndex = [] }) {
    const {
        installationsWithGeo,
        declaration,
    } = useSelector(store => ({
        installationsWithGeo: store.InstallationReducer.installationsWithGeo,
        declaration: store.AgriReducer.declaration,
    }), shallowEqual)

    const dispatch = useDispatch()

    const handleClose = () => {
        onValidateDeclaration()
        toggleModal()
    }

    return (
        <Dialog open={open}>
            <DefaultDialogTitle title={i18n.payAttention} onClose={toggleModal} />
            <DialogContent>
                <p>{i18n.pointsWithoutConsoDeclared}</p>
                <Grid container alignItems='center' justifyContent='space-evenly'>
                    {instsWithoutIndex.map((id) => {
                        const inst = installationsWithGeo.find((i) => i.id === id)
                        return (
                            <React.Fragment key={id}>
                                <Grid size={7} className='bold'>{`${i18n.point} ${inst.code}${inst.name ? ` - ${inst.name}` : ''} - ${inst.location}  - ${inst.parcel} ${inst.section}`}</Grid>
                                <Grid size={4}>
                                    <Button variant='contained' onClick={() => dispatch(push(`/survey/${declaration.idSurvey}/declaration/${declaration.idDeclaration}/usages/${id}/reel`))}>{i18n.change}</Button>
                                </Grid>
                            </React.Fragment>
                        )
                    })}
                </Grid>
                <p id='modal-description' className='italic'>{i18n.contactAdmin}</p>
            </DialogContent>
            <DialogActions>
                <Button variant='contained' onClick={handleClose}>
                    {i18n.ignoreAndValidateDeclaration}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

ModalWarnNoConso.propTypes = {
    open: PropTypes.bool.isRequired,
    toggleModal: PropTypes.func.isRequired,
    onValidateDeclaration: PropTypes.func.isRequired,
    instsWithoutIndex: PropTypes.arrayOf(PropTypes.number),
}
